<template>
  <div class="weixin-tip" v-show="maskShow">
    <img class="arrow" src="../../img/mobile/arrow.png" />
    <p class="one">1：点击右上角</p>
    <img class="group" src="../../img/mobile/group.png" />
    <p class="two">按钮</p>
    <p class="three">2：请选择默认浏览器打开</p>
  </div>
</template>

<script>
export default {
  props: ["maskShow"],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.weixin-tip {
  position: relative;
  .group {
    width: 0.38rem;
    height: 0.38rem;
    position: absolute;
    left: 5.2rem;
    top: 1.41rem;
  }
  .arrow {
    width: 0.71rem;
    height: 0.65rem;
    position: absolute;
    top: 0.6rem;
    right: -3.5rem;
  }
  p{
    font-size: 0.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    height: 0.42rem;
    line-height: 0.42rem;
  }
  .one {
    width: 3rem;
    position: absolute;
    top: 1.41rem;
    left: 3.15rem;
    text-align: left;
  }
  .two {
    width: 1rem;
    position: absolute;
    top: 1.41rem;
    left: 5.65rem;
    text-align: left;
  }
  .three {
    width: 4rem;
    position: absolute;
    top: 2.01rem;
    left: 3.15rem;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/downloadTip.vue